import router from "../router";

import { requestQuestionRegist, requestQnaList } from "@/apis/question_api";
import AdminClient from "../apis/adminClient";

const adminClient = new AdminClient();

const state = {
  qnaList: [],
  qnaPage: null,
  qnaPageTotal: 0,
  qnaTotalElemtnts: 0
};

const getters = {
  getQnaList(state) {
    return state.qnaList;
  },

  getQnaPage(state) {
    if (state.qnaPage === null) {
      return 0;
    } else {
      return state.qnaPage.pageNumber + 1;
    }
  },
  getQnaPageTotal(state) {
    return state.qnaPageTotal;
  },
  getQnaTotalElements(state) {
    return state.qnaTotalElemtnts;
  }
};

const mutations = {
  QNA_LIST(state, data) {
    state.qnaList = data.resultQnaList;
    state.qnaPage = data.page;
    state.qnaPageTotal = data.pageTotal;
    state.qnaTotalElemtnts = data.totalElemtnts;
  },
  QNA_LIST_ADD(state, data) {
    state.qnaList = [].concat.apply(state.qnaList, data.resultQnaList);
    state.qnaPage = data.page;
    state.qnaPageTotal = data.pageTotal;
    state.qnaTotalElemtnts = data.totalElemtnts;
  },
  QNA_INIT(state) {
    state.qnaList = [];
    state.qnaPage = null;
    state.qnaPageTotal = 0;
    state.qnaTotalElemtnts = 0;
  }
};

const actions = {
  async REQUEST_QNA_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await adminClient.getQnaList(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      if (data.page.pageNumber !== 0) {
        commit("QNA_LIST_ADD", data);
        return;
      }
      commit("QNA_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_QNA_REGIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await adminClient.registQna(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      if (data.page.pageNumber !== 0) {
        commit("QNA_LIST_ADD", data);
        return;
      }
      commit("QNA_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_QUESTION_REGIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestQuestionRegist(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }
      alert("가입 상담이 신청되었습니다");
      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
